import React from "react";
import SelectField from "./SelectField";

interface GenderFieldProps {
  id: string;
  name: string;
  value: string;
  onChange: (value: string) => void;
  label?: string;
  placeholder?: string;
  required?: boolean;
  error?: boolean | string;
  hint?: string;
  className?: string;
}

// Gender options for athlete registration
const genderOptions = [
  { value: "female", label: "Female" },
  { value: "male", label: "Male" },
  { value: "non_binary", label: "Non-binary" },
  { value: "prefer_not_to_say", label: "Prefer not to say" }
];

const GenderField: React.FC<GenderFieldProps> = ({
  id,
  name,
  value,
  onChange,
  label = "Gender",
  placeholder = "Select gender",
  required = false,
  error = false,
  hint,
  className = "",
}) => {
  return (
    <div className={className}>
      <SelectField
        id={id}
        name={name}
        label={label}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        required={required}
        error={error}
        hint={hint}
        options={genderOptions}
      />
    </div>
  );
};

export default GenderField; 